import {
  IValidator,
  ValidationError,
  ValidationResult,
} from "../types/validation";

class EmailValidator implements IValidator<{ value: string }> {
  validate(item: { value: string }): ValidationResult {
    const regexp =
      // eslint-disable-next-line no-control-regex
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    const isValid = regexp.test(item.value);
    const errors: ValidationError[] = isValid
      ? []
      : [
          {
            key: "invalid-value",
            message: "Email is invalid",
          },
        ];

    return new ValidationResult(errors);
  }
}

const emailValidator = new EmailValidator();

export default emailValidator;
